export default function BrowserFrame({ children, url = 'yourorg.lightning.force.com', dark = false, className = '' }) {
  return (
    <div
      className={`rounded-xl overflow-hidden border ${dark ? 'border-white/10 bg-[#16333a]' : 'border-[#10282C]/10 bg-white'} shadow-[0_32px_80px_-24px_rgba(16,40,44,0.35)] ${className}`}
    >
      <div className={`flex items-center gap-2 px-4 py-2.5 border-b ${dark ? 'border-white/10 bg-[#10282C]' : 'border-[#10282C]/8 bg-[#F0F4F3]'}`}>
        <span className="w-2.5 h-2.5 rounded-full bg-[#FD584F]/80" />
        <span className="w-2.5 h-2.5 rounded-full bg-[#f5c04e]/80" />
        <span className="w-2.5 h-2.5 rounded-full bg-[#3fce70]/80" />
        <div className={`ml-3 flex-1 max-w-sm px-3 py-1 rounded-md text-[11px] font-mono truncate ${dark ? 'bg-white/5 text-white/50' : 'bg-white text-[#10282C]/50'}`}>
          {url}
        </div>
      </div>
      {children}
    </div>
  );
}
